import { createTheme } from "@mui/material";



const theme = createTheme({
  palette: {
    primary: {
      main: "#92AF5D",
      light: "#C7DD94",
      dark: "#6D8F46",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#FFC107",
      light: "#FEB821",
      contrastText: "#000000"
    },
    background: {
      default: "#F5F5F5",
      paper: "#ffffff"
    },
    text: {
      primary: "#333333",
      main: "#000000",
      secondary: "#666666",
      shadow: "#858585"
    }
  },
  shadows: [
    'none',
    '0px 1px 3px rgba(0,0,0,0.2)',
    '0px 1px 5px rgba(0,0,0,0.2)',
    '0px 1px 8px rgba(0,0,0,0.2)',
    '0px 2px 4px rgba(0,0,0,0.2)',
    '0px 3px 5px rgba(0,0,0,0.2)',
    '0px 3px 5px rgba(0,0,0,0.24)',
    '0px 4px 5px rgba(0,0,0,0.2)',
    '0px 5px 5px rgba(0,0,0,0.2)',
    '0px 5px 6px rgba(0,0,0,0.2)',
    '0px 6px 6px rgba(0,0,0,0.2)',
    '0px 6px 7px rgba(0,0,0,0.2)',
    '0px 7px 8px rgba(0,0,0,0.2)',
    '0px 7px 8px rgba(0,0,0,0.24)',
    '0px 7px 9px rgba(0,0,0,0.2)',
    '0px 8px 9px rgba(0,0,0,0.2)',
    '0px 8px 10px rgba(0,0,0,0.2)',
    '0px 8px 11px rgba(0,0,0,0.2)',
    '0px 9px 11px rgba(0,0,0,0.2)',
    '0px 9px 12px rgba(0,0,0,0.2)',
    '0px 10px 13px rgba(0,0,0,0.2)',
    '0px 10px 13px rgba(0,0,0,0.24)',
    '0px 10px 14px rgba(0,0,0,0.2)',
    '0px 11px 14px rgba(0,0,0,0.2)',
    '0px 11px 15px rgba(0,0,0,0.2)',
  ],
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: { fontWeight: 700 }, // bold
    h2: { fontWeight: 600 }, // semi-bold
    body1: { fontWeight: 400, fontSize: 16 }, // normal
  }

});

export default theme;